<template>
  <div :class="[{'is-active': active}, 'season', season.className]" @click="$emit('clicked')">
    <div class="season-bg"></div>
    <div class="season-content">
      <h2 class="heading-season">{{ season.title }}</h2>
      <p class="subtitle-season">{{ season.subtitle }}</p>
    </div>
    <i class="selected"></i>
  </div>
</template>
<script>
export default {
  props: ['season', 'active']
}
</script>
<style lang="scss">
.season {
  padding-bottom: 50%;
  text-align: left;
  display: flex;
  position: relative;
  margin-bottom: 15px;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  @include media-breakpoint-up(md){
    width: calc(50% - 7.5px);
    height: 230px;
    padding: 0;
    margin-bottom: 15px;
  }
  @include media-breakpoint-up(xl){
    width: calc(33% - 15px);
    height: 320px;
    margin-bottom: 30px;
  }
  &:hover,
  &.is-active{
    .season-bg {
      transform: scale(1.1);
    }
    &::before{
      opacity: 1;
    }
  }
  &.is-active{
    .selected{
      transform: scale(1)
    }
  }
  &.empty{
    pointer-events: none;
    @include media-breakpoint-down(md){
      display: none;
    }
    &::before,
    &::after{
      display: none;
    }
  }
  // before & after used to simplify image setup per season
  &::before,
  &::after{
    content: '';
    position: absolute;
    z-index: 5;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(180deg, rgba(68, 75, 29, 0) 13.66%, #203820 102.33%);
  }
  &::before{
    opacity: 0;
    transition: all 0.2s ease-in-out;
    background: rgba($color-dark-green, 0.6);
  }
  .selected{
    z-index: 10;
    position: absolute;
    right: 15px;
    top: 15px;
    display: block;
    width: 40px;
    height: 40px;
    background: url('/assets/checkbox.svg') no-repeat center center;
    transform: scale(0);
    transition: .2s;
  }
  .season-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    transition: all 0.2s ease-in-out;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
  }

  &.is-early-mid-spring {
    .season-bg {
      @include seasonBg('early-mid-spring');
    }
  }
  &.is-late-spring-early-summer {
    .season-bg {
      @include seasonBg('late-spring-early-summer');
    }
  }
  &.is-mid-summer {
    .season-bg {
      @include seasonBg('mid-summer');
    }
  }
  &.is-late-summer-early-fall {
    .season-bg {
      @include seasonBg('late-summer-early-fall');
    }
  }
  &.is-mid-late-fall {
    .season-bg {
      @include seasonBg('mid-late-fall');
    }
  }
}
.season-content {
  padding: 0 30px;
  pointer-events: none;
  z-index: 10;
  position: absolute;
  bottom: 10px;
}
.heading-season {
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
}
.subtitle-season {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
}
</style>
